import React, { useState } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Button } from '@uhg-abyss/web/ui/Button';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { SubscribeToAPIModal } from '@src/common/SubscribeToAPIModal';
import { StartRegistrationButton } from '@src/common/StartRegistrationButton';
import { CardComponentWrapper } from './CardComponentWrapper';

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'row',
});

const BoxWrapper = styled('div', {
  display: 'flex',
  marginTop: '27px',

  '@screen >= $xs': {
    flexDirection: 'column',
    gap: '16px',
  },

  '@screen >= $xl': {
    flexDirection: 'row',
    gap: '93px',
  },
});

export const ConnectToOrganization = () => {
  const [showSubscribeAPIModal, setShowSubscribeAPIModal] = useState(false);
  const { navigate } = useRouter();

  const ScheduleMeetingTitle = 'Begin your API journey';
  const ScheduleMeetingSection =
    "We're excited to help you discover the right API solutions. Please answer a few brief questions about your organization and the services you provide so we can recommend the best approach. ";
  const StartRegistrationTitle = ' Register for API Marketplace';

  const StartRegistrationSection = (
    <div>
      Register to proceed with API implementation or to add new users from your
      organization. Your organizations Tax ID is required. View the{' '}
      <Link
        href={config('REGISTRATION_STEPS')}
        fontWeight="700"
        size="15"
        onClick={() => {
          const fileName = 'API Marketplace Registration Guide';
          const fileURL = config('REGISTRATION_STEPS');
          const fileContext = 'self-paced chameleon guide';
          event('DOWNLOAD_CLICK', {
            fileName,
            fileURL,
            fileContext,
          });
        }}
      >
        API Marketplace Registration Guide
      </Link>
      &nbsp; for more information.
    </div>
  );

  const ScheduleMeetingBtn = (
    <Button
      size="$lg"
      id="SubscribeToAPI"
      onClick={() => {
        const jobName = 'request a meeting with an api consultant';
        event('JOB_START', {
          event,
          jobName,
        });
        navigate('/welcome/intake');
      }}
    >
      Get started
    </Button>
  );

  const StartRegistrationBtn = (
    <StartRegistrationButton id="register-button" size="lg">
      Start registration
    </StartRegistrationButton>
  );

  return (
    <Container>
      <SubscribeToAPIModal
        showModal={showSubscribeAPIModal}
        modalOnClose={setShowSubscribeAPIModal}
      />
      <BoxWrapper>
        <CardComponentWrapper
          title={ScheduleMeetingTitle}
          section={ScheduleMeetingSection}
          button={ScheduleMeetingBtn}
        />
        <CardComponentWrapper
          title={StartRegistrationTitle}
          section={StartRegistrationSection}
          button={StartRegistrationBtn}
        />
      </BoxWrapper>
    </Container>
  );
};
